export const getCrewTypeList = (translations) => {
    const bum = translations?.branchAndUserMaster || {}
    return [
        { name: bum.driver || 'Driver', id: 1 },
        { name: bum.conductor || 'Conductor', id: 0 },
        { name: bum.coDriver || 'Co-Driver', id: 2 },
        { name: bum.sortingManager || 'Sorting Manager', id: 3 },
        { name: bum.sortingExecutive || 'Sorting Executive', id: 4 },
        { name: bum.loadingStaff || 'Loading Staff', id: 5 },
    ]
}

export const getHeaders = (translations) => {
    const bum = translations?.branchAndUserMaster || {}
    return [
        {
            headerName: bum.sn || 'SN',
            field: 'sn',
        },
        {
            headerName: bum.crewId || 'Crew ID',
            field: 'DriverConductorID',
        },
        {
            headerName: bum.crewName || 'Crew Name',
            field: 'DriverConductorName',
        },
        { headerName: bum.crewType || 'Crew Type', field: 'CrewType' },
        {
            headerName: bum.cityName || 'City Name',
            field: 'CityName',
        },
        {
            headerName: bum.mobileNo || 'Mobile No',
            field: 'ContactNo',
        },
        // {
        //     headerName: 'Modified By',
        //     field: 'ModifiedBy',
        // },
        // {
        //     headerName: 'Modified Date & Time',
        //     field: 'ModifiedOn',
        // },
        { headerName: bum.status || 'Status', field: 'Status' },
        { headerName: bum.edit || 'Edit', field: 'edit' },
        { headerName: bum.downloadQrSpaced || 'Download QR', field: 'downloadQr' },
    ]
}
